/**
 * External dependencies
 */
import type { Attributes } from '../../../../../packages/conversion-action-library/scroll/types';

/**
 * Internal dependencies
 */
import type { ConvertibleAction, Convert } from '../../types';

export function listenToScrollEvent(
	allActions: ReadonlyArray< ConvertibleAction >,
	convert: Convert
): void {
	const actions = allActions.filter( isScrollAction );
	if ( ! actions.length ) {
		return;
	}

	const maxScroll = actions.reduce(
		( r, a ) => ( a.attributes.value > r ? a.attributes.value : r ),
		0
	);
	const onScroll = () => {
		const scrollTop = window.scrollY;
		const windowHeight = window.innerHeight;
		const fullHeight = document.documentElement.scrollHeight;

		const scrollPercentage =
			( scrollTop / ( fullHeight - windowHeight ) ) * 100;

		convert(
			actions.filter(
				( action ) => scrollPercentage >= action.attributes.value
			)
		);

		if ( scrollPercentage >= maxScroll ) {
			document.removeEventListener( 'scroll', onScroll );
			document.removeEventListener( 'scroll', onScroll, true );
		}
	};

	document.addEventListener( 'scroll', onScroll );
	document.addEventListener( 'scroll', onScroll, true );
}

// =======
// HELPERS
// =======

function isScrollAction(
	action: ConvertibleAction
): action is ConvertibleAction< Attributes > {
	return 'nab/scroll' === action.type;
}
